module.exports = __webpack_public_path__ + "static/media/ursula.ffcb3610.jpg";